import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b0b0bdc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row items-center py-2 container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-200" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 2,
  class: "py-8 flex flex-row items-center container w-full"
}
const _hoisted_7 = { class: "flex flex-row ml-4 bg-white w-full" }
const _hoisted_8 = { class: "space-y-5 w-full" }
const _hoisted_9 = { class: "sm:flex flex-row items-center justify-between w-full" }
const _hoisted_10 = { class: "text-2xl" }
const _hoisted_11 = { class: "flex flex-row items-center" }
const _hoisted_12 = { class: "flex items-center pr-5" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Return to Jobs", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "View Job Candidates", -1))
const _hoisted_15 = { class: "container py-8" }
const _hoisted_16 = { class: "sm:flex space-x-5 space-y-6 sm:space-y-0 justify-center" }
const _hoisted_17 = { class: "sm:w-8/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CandidateInfo = _resolveComponent("CandidateInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_Loading, {
            active: _ctx.isLoading,
            "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
            "can-cancel": false,
            loader: "spinner",
            color: "#8908F9",
            width: 128,
            height: 128,
            opacity: 0.5,
            "is-full-page": true
          }, null, 8, ["active", "opacity"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.jobStore.title), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_router_link, {
                      type: "button",
                      to: "/jobs",
                      class: "text-primary bg-white px-4 py-2 hover:bg-gray-100"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      type: "button",
                      to: `/job-candidates?id=${_ctx.jobId}&by_stage_name=Talent+Pool`,
                      class: "text-primary bg-white px-4 py-2 hover:bg-gray-100"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ])
            ])
          ])
        ])),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass([_ctx.showOption === '' ? 'h-screen' : 'h-full', "min-h-screen z-10 inset-0 bg-black bg-opacity-50"])
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_CandidateInfo, {
                  userInfo: _ctx.userInfo,
                  onResetSelected: _ctx.resetSelected,
                  candidateId: _ctx.userInfo?.candidate_id,
                  key: "create"
                }, null, 8, ["userInfo", "onResetSelected", "candidateId"])
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}